// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"22":"4b42bad7","340":"20f733ef"}[chunkId] + ".css";
};